import { render, staticRenderFns } from "./Allies.vue?vue&type=template&id=031ef6dc"
import script from "./Allies.vue?vue&type=script&lang=js"
export * from "./Allies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports